import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeftIcon } from 'lucide-react';
interface PageHeaderProps {
  title: string;
  showBackButton?: boolean;
  rightContent?: React.ReactNode;
  leftContent?: React.ReactNode;
}
const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  showBackButton = true,
  rightContent,
  leftContent
}) => {
  const navigate = useNavigate();
  return <div className="bg-gray-900 p-4 flex items-center justify-between fixed top-0 left-0 right-0 z-10" data-id="element-44">
      <div className="w-1/4 flex justify-start" data-id="element-45">
        {leftContent || showBackButton && <button onClick={() => navigate('/')} className="text-[#51a7fa] hover:text-white" data-id="element-46">
              <ChevronLeftIcon size={24} data-id="element-47" />
            </button>}
      </div>
      <h1 className="text-2xl font-bold text-center flex-1" data-id="element-48">{title}</h1>
      <div className="w-1/4 flex justify-end" data-id="element-49">{rightContent}</div>
    </div>;
};
export default PageHeader;